import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import Slider from 'react-slick';
var SliderWrapper = /*#__PURE__*/function (_React$Component) {
  function SliderWrapper() {
    var _this;
    _classCallCheck(this, SliderWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SliderWrapper, [].concat(args));
    _defineProperty(_this, "slider", null);
    _defineProperty(_this, "settings", _objectSpread({
      dots: true,
      infinite: false,
      speed: 500,
      swipeToSlide: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      swipe: true,
      lazyLoad: 'ondemand',
      appendDots: function appendDots(dots) {
        return (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          React.createElement(React.Fragment, null, React.createElement("div", {
            className: "d-flex justify-content-center slick-dots mt-5"
          }, React.createElement("button", {
            type: "button",
            className: "btn btn-reset slick-prev",
            "aria-label": "Prevous slider",
            onClick: function onClick() {
              return _this.slider && _this.slider.slickPrev();
            }
          }), React.createElement("ul", {
            className: "p-0 mb-0 d-flex align-items-center"
          }, dots), React.createElement("button", {
            type: "button",
            className: "btn btn-reset slick-next",
            "aria-label": "Next slider",
            onClick: function onClick() {
              return _this.slider && _this.slider.slickNext();
            }
          })))
        );
      }
    }, _this.props.settings));
    return _this;
  }
  _inherits(SliderWrapper, _React$Component);
  return _createClass(SliderWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return React.createElement(Slider, _objectSpread(_objectSpread({}, this.settings), {}, {
        ref: function ref(c) {
          _this2.slider = c;
        },
        className: this.props.className || ''
      }), this.props.children);
    }
  }]);
}(React.Component);
export { SliderWrapper as default };